export default __webpack_public_path__ + "static/media/etapa4.fda5fb86.png";